module.exports = __webpack_public_path__ + "static/img/user_story2.d62d4fd5.png";